import * as React from 'react';

import styles from './InfoLayout.css';

interface IInfoItemProps {
  title: string;
  value: string | number;
}

export function InfoItem(props: IInfoItemProps) {
  const { title, value } = props;

  return (
    <div className={styles['info_item']}>
      <div className={styles['info_title']}>{title}</div>
      <div className={styles['info_value']}>{value}</div>
    </div>
  );
}
